module.exports = __webpack_public_path__ + "static/media/1-mobile.668d1a23.jpg";